import classnames from "classnames";

import { calculateNodeCoordinates } from "../../utils";

const getStyleClassNames = levelIndex =>
  classnames("text-xs w-auto border ", {
    "bg-green-300": levelIndex === 0,
  });

const getNodeData = (
  node,
  levelIndex,
  totalLevels,
  nodeIndex,
  totalNodes,
  max
) => ({
  id: node.label,
  data: { label: node.label },
  type: node.type || "default",
  position: calculateNodeCoordinates(
    levelIndex,
    totalLevels,
    nodeIndex,
    totalNodes,
    max
  ),
  sourcePosition: "right",
  targetPosition: "left",
  className: getStyleClassNames(levelIndex),
});

export { getNodeData };
